module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
var hidden = ( u.isTrue(showLabel) ? '' : 'hidden');
    //console.log('value', value)

var labelText = label;

if (label.startsWith('%1')) {
    var extra = label.substring(2);
    labelText = value + extra;
}


    ; __append("\r\n\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control pf-selectable text has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; min-height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; text-align: left; font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n             font-size: ")
    ; __append(escapeFn( fontSize ))
    ; __append("px; font-style: ")
    ; __append(escapeFn( textStyle ))
    ; __append("; font-weight: ")
    ; __append(escapeFn( textWeight ))
    ; __append(";\">\r\n\r\n    <div class=\"size-handle-top\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core\" >\r\n\r\n        <div class=\"progress\" style=\"height: 6px; width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;  border: solid ")
    ; __append(escapeFn(borderColor))
    ; __append(" 1px;\">\r\n            <div role=\"progressbar\"\r\n                 aria-valuenow=\"")
    ; __append(escapeFn( value ))
    ; __append("\"\r\n                 aria-valuemin=\"0\" aria-valuemax= \"100\"\r\n                 style=\" width: ")
    ; __append(escapeFn( value ))
    ; __append("%;\r\n                         height: 6px;\r\n                         border: none;\r\n                        background-color: ")
    ; __append(escapeFn(barColor))
    ; __append(";\">\r\n            </div>\r\n        </div>\r\n        <span              ")
    ; __append(escapeFn( hidden ))
    ; __append("\r\n                            style=\"margin: 1px;\r\n                                   height:")
    ; __append(escapeFn( u.extractNum(height)-6 ))
    ; __append("px;\r\n                                   width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n                                   font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                                   font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                                   font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                                   font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                                   color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(" \">")
    ; __append(escapeFn( labelText ))
    ; __append("\r\n        </span>\r\n\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n")
  }
  return __output;

}